@if ((!!user && !!user.profile) || isLoginPage) {
  <router-outlet></router-outlet>
}
@if ((!user || !user.profile) && !isLoginPage) {
  <div class="w-full h-screen flex items-center justify-center pb-[25vh]">
    <div class="flex flex-col gap-3 items-center">
      <img src="/assets/images/logo.png" class="w-[150px]" />
      <p class="text-primary-main !font-bold text-base">
        ARAD MEAT AUTOMATION SYSTEM
      </p>
      <p class="!mt-1 text-[14px]" style="direction: rtl">در حال بارگذاری...</p>
    </div>
  </div>
}

<!--IMPORTANT: if changing the type, make a change also in angular.json (style import) -->
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#ffffff"
  type="ball-spin-clockwise"
>
</ngx-spinner>
